export const PROVIDER_ARSEN_AI_DATA_EXTRACTION =
  "arsen_ai_document_data_extraction" as const;
export const PROVIDER_ARSEN_AI_ENRICH = "arsen_ai_enrich" as const;
export const PROVIDER_BASELAYER = "baselayer" as const;
export const PROVIDER_BBB = "bbb" as const;
export const PROVIDER_BLU_COGNITION = "blu_cognition" as const;
export const PROVIDER_CHART = "chart" as const;
export const PROVIDER_CHART_TAX_RECORDS = "chart_tax_records" as const;
export const PROVIDER_CLEAR = "clear" as const;
export const PROVIDER_CLEAR_ADVERSE_MEDIA_REPORT =
  "clear_adverse_media_report" as const;
export const PROVIDER_CLEAR_ADVERSE_MEDIA_SEARCH =
  "clear_adverse_media_search" as const;
export const PROVIDER_CLEAR_COURT_SEARCH = "clear_court_search" as const;
export const PROVIDER_CLEAR_ID_BUSINESS_REPORT =
  "clear_risk_inform_business_report" as const;
export const PROVIDER_CLEAR_ID_BUSINESS_SEARCH =
  "clear_risk_inform_business_search" as const;
export const PROVIDER_CLEAR_ID_CONFIRM_BUSINESS =
  "clear_id_confirm_business" as const;
export const PROVIDER_CLEAR_ID_CONFIRM_PERSON =
  "clear_id_confirm_person" as const;
export const PROVIDER_CLEAR_ID_PERSON_REPORT =
  "clear_risk_inform_person_report" as const;
export const PROVIDER_CLEAR_ID_PERSON_SEARCH =
  "clear_risk_inform_person_search" as const;
export const PROVIDER_CLEAR_PERSON_REPORT =
  "clear_risk_inform_person_report" as const;
export const PROVIDER_CLEAR_PERSON_SEARCH =
  "clear_risk_inform_person_search" as const;
export const PROVIDER_CODAT = "codat" as const;
export const PROVIDER_DATA_MERCH = "data_merch" as const;
export const PROVIDER_DNB_BM_L1 = "dnb_bm_l1" as const;
export const PROVIDER_DNB_CI_L2 = "dnb_ci_l2" as const;
export const PROVIDER_DNB_FI_L4 = "dnb_fi_l4" as const;
export const PROVIDER_DOCUSIGN = "docusign" as const;
export const PROVIDER_EKATA = "ekata" as const;
export const PROVIDER_ENIGMA = "enigma" as const;
export const PROVIDER_ENIGMA_LOOKUP = "enigma_lookup" as const;
export const PROVIDER_ENIGMA_MATCH = "enigma_match" as const;
export const PROVIDER_EQUIFAX = "equifax" as const;
export const PROVIDER_EQUIFAX_BUSINESS_MATCH =
  "equifax_business_match" as const;
export const PROVIDER_EQUIFAX_BUSINESS_PRINCIPAL_REPORT =
  "equifax_business_principal_report" as const;
export const PROVIDER_EQUIFAX_CFN_REPORT = "equifax_cfn_report" as const;
export const PROVIDER_EQUIFAX_SBFE_REPORT = "equifax_sbfe_report" as const;
export const PROVIDER_EXPERIAN = "experian" as const;
export const PROVIDER_EXPERIAN_BANKRUPTCIES = "experian_bankruptcies" as const;
export const PROVIDER_EXPERIAN_BUSINESS_CONTACTS =
  "experian_business_contacts" as const;
export const PROVIDER_EXPERIAN_BUSINESS_MATCH =
  "experian_business_match" as const;
export const PROVIDER_EXPERIAN_BUSINESS_MATCH_CANADA =
  "experian_business_match_canada" as const;
export const PROVIDER_EXPERIAN_BUSINESS_MATCH_QUICK_SEARCH =
  "experian_business_quick_search" as const;
export const PROVIDER_EXPERIAN_COMMERCIAL_COLLECTIONS =
  "experian_commercial_collections" as const;
export const PROVIDER_EXPERIAN_CORPORATE_REGISTRATIONS =
  "experian_corporate_registrations" as const;
export const PROVIDER_EXPERIAN_CREDIT_STATUS =
  "experian_credit_status" as const;
export const PROVIDER_EXPERIAN_FACTS = "experian_business_facts" as const;
export const PROVIDER_EXPERIAN_FRAUD = "experian_fraud" as const;
export const PROVIDER_EXPERIAN_FRAUD_SHIELDS =
  "experian_fraud_shields" as const;
export const PROVIDER_EXPERIAN_FSR = "experian_fsr" as const;
export const PROVIDER_EXPERIAN_FSR_V2 = "experian_fsr_v2" as const;
export const PROVIDER_EXPERIAN_GDN_CANADIAN_PROFILE_REPORT =
  "experian_gdn_canadian_profile_report" as const;
export const PROVIDER_EXPERIAN_GDN_COMPANY_PROFILE =
  "experian_gdn_company_profile" as const;
export const PROVIDER_EXPERIAN_GDN_EXTENDED_REPORT =
  "experian_gdn_extended_report" as const;
export const PROVIDER_EXPERIAN_GDN_RISK_CHECK =
  "experian_gdn_risk_check" as const;
export const PROVIDER_EXPERIAN_GDN_SMALL_REPORT =
  "experian_gdn_small_report" as const;
export const PROVIDER_EXPERIAN_INTELLISCORE = "experian_intelliscore" as const;
export const PROVIDER_EXPERIAN_INTELLISCORE_V2 = "intelliscore" as const;
export const PROVIDER_EXPERIAN_INTELLISCORE_V3 = "intelliscore_v3" as const;
export const PROVIDER_EXPERIAN_INTELLISCORE_V3_LONG =
  "experian_intelliscore_v3" as const;
export const PROVIDER_EXPERIAN_JUDGMENTS = "experian_judgments" as const;
export const PROVIDER_EXPERIAN_LEGAL_COLLECTIONS =
  "experian_legal_collections" as const;
export const PROVIDER_EXPERIAN_LIENS = "experian_liens" as const;
export const PROVIDER_EXPERIAN_TRADES = "experian_trades" as const;
export const PROVIDER_EXPERIAN_UCCS = "experian_uccs" as const;
export const PROVIDER_FMCSA = "fmcsa" as const;
export const PROVIDER_FOURSQUARE = "foursquare" as const;
export const PROVIDER_GBP = "gbp" as const;
export const PROVIDER_INSCRIBE = "inscribe" as const;
export const PROVIDER_LEXISNEXIS_BUSINESS_CREDIT =
  "lexis_nexis_small_business_credit_score" as const;
export const PROVIDER_LEXISNEXIS_CONTACT_CARD_REPORT =
  "lexis_nexis_contact_card_report" as const;
export const PROVIDER_LEXISNEXIS_EMAIL_SEARCH =
  "lexis_nexis_email_search" as const;
export const PROVIDER_LEXISNEXIS_KYB_REPORT = "lexis_nexis_kyb_report" as const;
export const PROVIDER_LEXISNEXIS_KYB_SEARCH = "lexis_nexis_kyb_search" as const;
export const PROVIDER_LEXISNEXIS_LIENS_REPORT =
  "lexis_nexis_liens_report" as const;
export const PROVIDER_LEXISNEXIS_LIENS_SEARCH =
  "lexis_nexis_liens_and_judgment_search" as const;
export const PROVIDER_LEXISNEXIS_RISK_VIEW = "lexis_nexis_risk_view" as const;
export const PROVIDER_LEXIS_NEXIS = "lexisNexis" as const;
export const PROVIDER_LEXIS_NEXIS_BANKRUPTCY_REPORT =
  "lexis_nexis_bankruptcy_report" as const;
export const PROVIDER_LEXIS_NEXIS_BANKRUPTCY_SEARCH =
  "lexis_nexis_bankruptcy_search" as const;
export const PROVIDER_LEXIS_NEXIS_FILING_REPORT =
  "lexis_nexis_ucc_filing_report" as const;
export const PROVIDER_LEXIS_NEXIS_FILING_SEARCH =
  "lexis_nexis_ucc_filing_search" as const;
export const PROVIDER_LEXIS_NEXIS_JUDGMENTS_REPORT =
  "lexis_nexis_judgments_report" as const;
export const PROVIDER_LEXIS_NEXIS_JUDGMENTS_SEARCH =
  "lexis_nexis_liens_and_judgment_search" as const;
export const PROVIDER_LEXIS_NEXIS_KYC = "lexis_nexis_kyc" as const;
export const PROVIDER_LEXIS_NEXIS_KYC_REPORT =
  "lexis_nexis_kyc_report" as const;
export const PROVIDER_MANTA = "manta" as const;
export const PROVIDER_MIDDESK = "middesk" as const;
export const PROVIDER_MIDDESK_BUSINESS_SEARCH =
  "middesk_business_search" as const;
export const PROVIDER_MONEYTHUMB = "MoneyThumb" as const;
export const PROVIDER_MONEYTHUMB_CFA = "moneythumb_cfa" as const;
export const PROVIDER_MONEYTHUMB_TRANSACTIONS =
  "moneythumb_transactions" as const;
export const PROVIDER_NUMVERIFY = "numverify" as const;
export const PROVIDER_OCROLUS = "ocrolus" as const;
export const PROVIDER_OCROLUS_CFA = "ocrolus_cfa" as const;
export const PROVIDER_OCROLUS_CFA_V2 = "ocrolus_cfa_v2" as const;
export const PROVIDER_OCROLUS_CFF = "ocrolus_cff" as const;
export const PROVIDER_OCROLUS_ET = "ocrolus_enriched_transactions" as const;
export const PROVIDER_OCROLUS_FRAUD_SIGNALS = "ocrolus_fraud_signals" as const;
export const PROVIDER_PERSONA = "persona" as const;
export const PROVIDER_PLAID = "plaid" as const;
export const PROVIDER_PLAID_ASSET_REPORT = "plaid_asset_report" as const;
export const PROVIDER_PLAID_BANK_DATA = "plaid_bank_data" as const;
export const PROVIDER_PRISM_DATA = "prism_data" as const;
export const PROVIDER_SENTILINK = "sentilink" as const;
export const PROVIDER_SENTILINK_DOB_COMPLETION =
  "sentilink_dob_completion" as const;
export const PROVIDER_SENTILINK_SSN_COMPLETION =
  "sentilink_ssn_completion" as const;
export const PROVIDER_SOCURE_FRAUD = "socure_fraud" as const;
export const PROVIDER_SOCURE_KYC = "socure_kyc" as const;
export const PROVIDER_SPINWHEEL = "spinwheel" as const;
export const PROVIDER_TAX_STATUS_VERIFY_BUSINESS =
  "tax_status_verify_business" as const;
export const PROVIDER_TAX_STATUS_VERIFY_INDIVIDUAL =
  "tax_status_verify_individual" as const;
export const PROVIDER_TRANSUNION = "transunion" as const;
export const PROVIDER_TRANSUNION_PERSONAL_CREDIT =
  "transunion_credit_report" as const;
export const PROVIDER_TRIPADVISOR = "tripadvisor" as const;
export const PROVIDER_TRYCHART = "try_chart" as const;
export const PROVIDER_TWILIO = "twilio_lookup" as const;
export const PROVIDER_VOUCHED = "vouched" as const;
export const PROVIDER_VOUCHED_CROSS_CHECK = "vouched_cross_check" as const;
export const PROVIDER_VOUCHED_VERIFICATION = "vouched_verification" as const;
export const PROVIDER_YELLOW_PAGES = "yellow_pages" as const;
export const PROVIDER_YELP = "yelp" as const;
export const REPORT = "report" as const;
export const SEARCH = "search" as const;

/**
 * Consumer score models are NOT service IDs - they are parameters passed to services.
 * These should never be added to the commercial data queue.
 */
const CONSUMER_SCORE_MODELS = new Set([
  // Experian BOP score models
  "fico8",
  "fico9",
  "fico_advanced2",
  "fico_v2",
  "vantage4",
  // Equifax BPR score models
  "vantage4",
  "fico5",
  // TransUnion score models
  "fico4",
  "fico10",
  "fico_bankruptcy2",
  "vantage1",
  "vantage2",
  "vantage3",
  "vantage3_0",
]);

/**
 * Group-level IDs that are NOT valid in backend's BusinessCreditService::SERVICES.
 * These require granular service IDs instead (e.g., use experian_intelliscore not experian).
 */
const INVALID_GROUP_LEVEL_IDS = new Set<string>([
  PROVIDER_EXPERIAN,
  PROVIDER_EQUIFAX,
  "dnb",
  PROVIDER_LEXIS_NEXIS,
  PROVIDER_TRANSUNION,
  PROVIDER_ENIGMA,
  "rutter",
  "socure",
  PROVIDER_NUMVERIFY,
  PROVIDER_TWILIO,
]);

/**
 * Validates a service ID and returns it if valid, or undefined if invalid.
 * This function filters out IDs that should NOT be sent to the backend API.
 *
 * Returns undefined for:
 * - Consumer score models (fico8, vantage4, etc.) - these are parameters, not service IDs
 * - Invalid group-level IDs (experian, equifax, dnb) - these require granular service IDs
 * - Composite IDs with hyphens (service-fico8) - these are WebSocket event IDs, not API IDs
 *
 * Returns the original serviceId for all other cases (valid granular or group-level IDs).
 */
export const toValidApiServiceId = (serviceId: string): string | undefined => {
  // Filter out consumer score models - these are NOT service IDs
  if (CONSUMER_SCORE_MODELS.has(serviceId)) {
    return undefined;
  }

  // Filter out invalid group-level IDs
  if (INVALID_GROUP_LEVEL_IDS.has(serviceId)) {
    return undefined;
  }

  // Filter out composite IDs (e.g., "experian_bop_blended_prequalification-fico8")
  // Valid service IDs use underscores, not hyphens
  if (serviceId.includes("-")) {
    return undefined;
  }

  // Pass through the service ID as-is
  // The backend will validate if it's in BusinessCreditService::SERVICES
  return serviceId;
};
